package com.zq.webproject.ui.withdraw

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.Font
import androidx.compose.material3.TabRowDefaults.tabIndicatorOffset
import webproject.composeapp.generated.resources.Res
import webproject.composeapp.generated.resources.font_song
// 统一字体
private val CaiFont: FontFamily
    @Composable
    get() = FontFamily(Font(Res.font.font_song))

/**
 * 提现记录界面
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun WithdrawRecordScreen(
    onBackClick: () -> Unit
) {
    println("WithdrawRecordScreen - 渲染提现记录界面") // 日志输出

    // 创建ViewModel实例
    val viewModel = remember { WithdrawViewModel() }

    // Tab状态：0-申请列表，1-成功列表
    var selectedTabIndex by remember { mutableStateOf(0) }

    Scaffold(
        topBar = {
            TopAppBar(
                title = {
                    Text(
                        text = "提现记录",
                        fontFamily = CaiFont,
                        fontWeight = FontWeight.Bold
                    )
                },
                navigationIcon = {
                    IconButton(onClick = {
                        println("WithdrawRecordScreen - 点击返回按钮") // 日志输出
                        onBackClick()
                    }) {
                        Icon(
                            imageVector = Icons.AutoMirrored.Filled.ArrowBack,
                            contentDescription = "返回"
                        )
                    }
                },
                colors = TopAppBarDefaults.topAppBarColors(
                    containerColor = Color(0xFF1E88E5),
                    titleContentColor = Color.White,
                    navigationIconContentColor = Color.White
                )
            )
        }
    ) { paddingValues ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(paddingValues)
                .background(Color(0xFFF5F5F5))
        ) {
            // Tab切换栏
            TabRow(
                selectedTabIndex = selectedTabIndex,
                containerColor = Color.White,
                contentColor = Color(0xFF1E88E5),
                indicator = { tabPositions ->
                    TabRowDefaults.SecondaryIndicator(
                        Modifier.tabIndicatorOffset(tabPositions[selectedTabIndex]),
                        color = Color(0xFF1E88E5)
                    )
                }
            ) {
                Tab(
                    selected = selectedTabIndex == 0,
                    onClick = {
                        println("WithdrawRecordScreen - 切换到申请列表Tab") // 日志输出
                        selectedTabIndex = 0
                    },
                    text = {
                        Text(
                            text = "申请列表",
                            fontFamily = CaiFont,
                            fontWeight = if (selectedTabIndex == 0) FontWeight.Bold else FontWeight.Normal
                        )
                    }
                )
                Tab(
                    selected = selectedTabIndex == 1,
                    onClick = {
                        println("WithdrawRecordScreen - 切换到成功列表Tab") // 日志输出
                        selectedTabIndex = 1
                    },
                    text = {
                        Text(
                            text = "成功列表",
                            fontFamily = CaiFont,
                            fontWeight = if (selectedTabIndex == 1) FontWeight.Bold else FontWeight.Normal
                        )
                    }
                )
            }

            // 列表内容
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color.White)
            ) {
                when (selectedTabIndex) {
                    0 -> {
                        if (viewModel.pendingRecords.isEmpty()) {
                            EmptyState("暂无申请记录")
                        } else {
                            WithdrawRecordList(records = viewModel.pendingRecords)
                        }
                    }
                    1 -> {
                        if (viewModel.successRecords.isEmpty()) {
                            EmptyState("暂无成功记录")
                        } else {
                            WithdrawRecordList(records = viewModel.successRecords)
                        }
                    }
                }
            }
        }
    }
}